import React, { Component } from "react";
import ReactSlider from "react-slider";
import "./verticaltimeline.css";
class VerticalTimeline extends Component {

    render(){
        const {data} = this.props 
        return (
            <ReactSlider
            className="vertical-slider"
            markClassName="example-mark"
            trackClassName={data.length-1 > 0? "example-track" : ""}
            defaultValue={0}
            value={0}
            min={0}
            max={data.length-1}
            marks
            renderMark={(props) => {
                if(data[props.key].status === "FINISHED"){
                    props.className = "example-mark example-mark-completed";
                }
                if(data[props.key].status === "CURRENT"){
                    props.className = "example-mark example-mark";
                }
                if(data[props.key].status === "PLANNED"){
                    props.className = "example-mark example-mark-active";
                }
                return <span {...props} />;
            }}
            orientation="vertical" />
        )
    }

} export default VerticalTimeline;



// WEBPACK FOOTER //
// ./src/views/Transporter/TrackAndTraceTracker/VerticalTimeline/index.jsx